import {
  store,
  addComboToOrder,
  addOrderForEditDetails,
  addOrderItems,
  deleteAllOrderItems,
  setOrderTableNumber,
  changeDeliveryType,
  changeDeliveryAddress
} from "@redux"
import convertOrderCombosToCartCombos from "./convertOrderCombosToCartCombos"
import convertOrderItemsToCartItems from "./convertOrderItemsToCartItems"

const movePreviousOrderToCartForEdit = (
  previousOrder,
  tableNumber,
  subPaymentItems = {}
) => {
  const orderItems =
    convertOrderItemsToCartItems(
      previousOrder.items
    )

  const combos =
    convertOrderCombosToCartCombos(
      previousOrder.items
    )

  store.dispatch(
    deleteAllOrderItems()
  )

  combos.forEach(combo =>
    store.dispatch(
      addComboToOrder(combo)
    )
  )

  store.dispatch(
    addOrderItems(orderItems)
  )

  store.dispatch(
    changeDeliveryType(
      previousOrder.deliveryType
    )
  )

  if (previousOrder.deliveryType === "delivery") {
    store.dispatch(
      changeDeliveryAddress(
        previousOrder.address
      )
    )
  }

  store.dispatch(
    setOrderTableNumber(
      tableNumber
    )
  )

  const couponCodes = []
  previousOrder.couponData.forEach(c =>
    c.couponType !== "comboset" &&
    couponCodes.push(c.couponCode)
  )

  const discounts = []
  previousOrder.couponData.forEach(c =>
    c.couponType !== "comboset" &&
    discounts.push({
      couponCode: c.couponCode,
      couponCanUsed: true,
      foodDiscount: c.foodDiscount,
      deliveryDiscount: c.deliveryDiscount,
      items: c.details
    })
  )

  const selectedUserAccount = {
    _id: previousOrder.accountId,
    fullName: previousOrder.customerFullName,
    mobilePhone: previousOrder.customerMobilePhone
  }

  store.dispatch(
    addOrderForEditDetails({
      date: previousOrder.date,
      orderId: previousOrder._id,
      note: previousOrder.note,
      accountId: previousOrder.accountId,
      orderCode: previousOrder.code,
      shiftId: previousOrder.shiftId,
      items: [...orderItems],
      combos: [...combos],
      selectedUserAccount,
      subPaymentItems,
      couponCodes,
      tableNumber,
      discounts,
      isOffline: false,
      address: previousOrder.address,
      deliveryService: previousOrder.deliveryService,
      deliveryType: previousOrder.deliveryType,
      isGuestOrder: previousOrder.isGuestOrder
    })
  )
}

export default movePreviousOrderToCartForEdit